import styled from "styled-components"

export default function BottomButton() {
  return (
    <BottomButtonBlock>
      <KakaoLink href={'http://pf.kakao.com/_gmtJs/chat'} target={'_blank'}>문의하기</KakaoLink>
    </BottomButtonBlock>
  )
}

const BottomButtonBlock = styled.div``;

const KakaoLink = styled.a`
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (16 / 375));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(100vw * (15 / 375)) 0;
  background-color: #F7F7F7;
  border-radius: calc(100vw * (5 / 375));
`;